<template>
  <div>
    <div class="modal" v-bind:class="{ 'is-active': itemId }">
      <div class="modal-background"></div>
      <div v-if="item.info" class="bottom-fixed w-100">
        <div class="modal-card fade has-background-light content-centered">
          <div class="modal-card-body is-paddingless overflow-x-hidden">
            <div
              v-if="image"
              v-lazy:background-image="image"
              class="bg-img bg-cover vh-55"
            >
            </div>
            <div class="panel-heading has-background-white sticky top-0 padding-5">
              <p class="title has-text-weight-medium is-4 overflow-hidden">
                {{item.info.longName}}
                <a class="delete is-medium is-pulled-right mt-5 mr-5" @click.prevent="removeItem"></a>
              </p>
            </div>
            <div class="padding-5">
              <p class="is-size-6" v-if="item.info.description">{{item.info.description}}</p>
              <div class="tags mt-5" v-if="tagIds">
                <template v-for="tagId in tagIds">
                  <span :key="'mob_diag_tag_'+tagId" class="tag">{{tagName(tagId)}}</span>
                </template>
              </div>
              <!-- <div class="columns is-mobile overflow-y-hidden " v-if="dealsForItem">
                <div v-for="deal in dealsForItem" :key="'cat_deal_'+deal.mid" class="column is-two-thirds-mobile is-one-third-tablet is-narrow" @click="displayDealDetail(deal.mid)">
                  <article class="level box is-mobile padding-5 h-100">
                    <div class="level-left pr-5">
                      <span class="has-text-primary" v-html="deal.dealTag"></span>
                    </div>
                  </article>
                </div>
              </div> -->
              <div>
                <template v-for="(varAttr, varAttrIndex) in varAttrComb">
                  <div :key="'mob_diag_varname_'+varAttr.name">
                    <ul>
                      <p class="is-size-5">{{varAttr.name}}</p>
                      <template v-for="varValue in varAttr.values">
                        <li :key="'mob_diag_varval_'+varValue.value" class="control">
                          <label class="radio columns is-mobile">
                            <div class="column">
                              <input
                                type="radio"
                                :value="varValue.value"
                                v-model="varSelection[varAttr.name]"
                                :name="varAttr.name"
                                @change="defineVariantComb(varAttr.name, varValue.value)"
                                class="mr-5"
                              />
                              {{varValue.value}}
                            </div>
                            <div
                              class="column has-text-right"
                              v-if="varAttrIndex+1 === item.variantAttributes.length"
                              v-html="getVairantPriceByValue(varAttr, varValue.value)"
                            ></div>
                          </label>
                        </li>
                      </template>
                    </ul>
                  </div>
                </template>
              </div>
              <br />
              <div v-if="optionSets">
                <p class="is-size-5" v-if="optionSets && optionSets.length !== 0">Select Addons</p>
                <div
                  v-for="(optionSet, optionsetId) in optionSets"
                  :key="'mob_diag_opset_'+optionsetId"
                  class="content"
                >
                  <template v-if="optionSet">
                    <p>
                      <span class="title has-text-weight-medium is-size-6">{{ optionSet.label || optionSet.name }}</span>
                      <span class="subtitle is-size-6">{{getMinMaxText(optionSet)}}</span>
                      <span
                        class="help is-danger"
                        v-if="errors.optionSetErrors[optionsetId]"
                      >{{ errors.optionSetErrors[optionsetId].msg }}</span>
                    </p>
                    <template v-for="(option, index) in optionSet.options">
                      <div
                        :key="'mob_diag_option_item_'+option.uid+index"
                        v-if="option"
                        class="level lineheight-small is-mobile"
                        :class="[isOutOfStock(option.itemId) ? 'is-text-linethrough' : '']"
                      >
                        <div class="level-left">
                          <quantity-btn
                            label="Add"
                            fieldPlaceHolder="Quantity"
                            v-model="cartItemOptions[option.uid].baseQty"
                            labelHtml="<span class='icon'>
                                          <font-awesome-icon icon='check-square'/>
                                      </span>"
                            :max="option.max"
                            :btnCls = "isOutOfStock(option.itemId) ? 'is-static' : ''"
                            fieldCls="border-box"
                          />
                          <span class="ml-5 is-size-6">{{ option.optionName || options.name }}</span>
                        </div>
                        <span class="level-right" v-html="formatPrice(option.price)"></span>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <footer class="mt-5 sticky has-backgroud-white">
            <UiNotification
              v-if="this.displayNotification"
              cls="is-danger"
              msg="Item cannot be added to cart. Please review your customization"
              v-on:closeNotification="closeNotification"
              fade="true"
              closable="true"
            ></UiNotification>
            <UiNotification
              v-if="errors.isOutOfStock"
              cls="is-danger"
              :msg="errors.isOutOfStock.msg"
              fade="true"
            ></UiNotification>
            <UiNotification
              v-if="errors.isNotAvailable"
              cls="is-danger"
              :msg="errors.isNotAvailable.msg"
              fade="true"
            ></UiNotification>
            <div
              class="is-pulled-left subtitle is-size-4 ml-5 mt-5"
              v-html="formatPrice(Math.round(cartItem.itemPriceTotal + cartItem.itemOptionTotal))"
            ></div>
            <div class="is-pulled-right padding-5 level is-mobile">
              <quantity-btn
                label="Add"
                fieldPlaceHolder="Quantity"
                btnCls="is-hidden"
                v-on:removeitem="removeItem"
                fieldCls="border-box"
                v-model="cartItem.quantity"
                class="level-left mr-5"
              ></quantity-btn>
              <a class="button is-primary is-outlined level-right" v-on:click="addAction">Add</a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Util from "@/util";
import Constants from "@/util/constants";
import quantityBtn from "@/components/ux/QuantityButton";
import UiNotification from "@/views/common/Notification";

export default {
  name: "itemDialog",
  components: {
    quantityBtn,
    UiNotification
  },
  data() {
    return {
      itemNumber: null,
      itemId: null,
      item: {},
      cartItem: {},
      active_var: null,
      varMap: [],
      varSelection: {},
      varItem: null,
      varAttrComb: [],
      cartItemOptions: {},
      optionSets: null,
      optionSetErrors: {},
      displayNotification: false,
      isItemUpdate: false,
      errors: []
    };
  },
  computed: {
    image() {
      if (this.item.info.imagePath) {
        return `${this.item.info.imagePath}/450x300`;
      }
      return this.item.info.imageURL;
    },
    currency() {
      return Constants.currency[this.$store.getters["business/currency"]];
    },
    ...mapGetters("catalog", ["getItem", "getOptionSet", "isOutOfStock", "isItemAvailable", "getApplicableDeals", "itemPrice"]),
    variantCombimation() {
      let varCombMap = {};
      let varCombs = [];
      this.item.variants.forEach(variant => {
        varCombs.push(
          Util.convertNamValToObj(variant.variantValues, {
            name: "name",
            value: "value"
          })
        );
      });
      varCombMap = varCombs.reduce((varCombMap, varAttrs, index) => {
        Object.keys(varAttrs).forEach((varAttr, varAttrIndex) => {
          let label = [varAttr, varAttrs[varAttr]].join(":");
          if (!varCombMap[label]) {
            varCombMap[label] = {};
            Object.keys(varAttrs).forEach(key => {
              if (key !== varAttr) {
                varCombMap[label][key] = [varAttrs[key]];
              }
            });
          } else {
            Object.keys(varAttrs).forEach(key => {
              if (key !== varAttr) {
                if (varCombMap[label][key]) {
                  varCombMap[label][key].push(varAttrs[key]);
                }
              }
            });
          }
        }, "");

        return varCombMap;
      }, {});
      return varCombMap;
    },
    tagIds() {
      if (this.varItem) {
        return this.varItem.info.tagIds;
      }
      return this.item.info.tagIds;
    },
    dealsForItem () {
      let deals = Util.cloneObj(this.getApplicableDeals())
      const item = this.varItem || this.item
      if (Util.isEmpty(deals)) {
        return []
      }
      return deals.filter(deal => {
        if (!Util.isEmpty(deal.categoryIds) && deal.categoryIds.includes(item.info.categoryId)) {
          return deal
        }
      })
    }
  },
  watch: {
    cartItem: {
      handler: function(item) {
        if (Util.isEmpty(item)) {
          return;
        }
        this.updateItem(item);
      },
      deep: true
    },
    active_var: function(itemId) {
      if (Util.isEmpty(itemId)) {
        return;
      }
      this.varItem = this.item.variants.find(variant => variant.mid === itemId);
    },
    cartItemOptions: {
      handler: function(cartItemOptions) {
        this.validateCartItemOptions(cartItemOptions);
        this.updateCartItemOptions(cartItemOptions);
      },
      deep: true
    },
    varSelection: {
      handler: function(varSelection) {
        if (Util.isEmpty(varSelection)) {
          return;
        }
        this.selectVariant(varSelection);
      },
      deep: true
    },
    varItem: function(varItem) {
      this.updateOptionSets();
      this.createCartItemOptions();
      if (this.isOutOfStock(varItem.mid)) {
        this.errors.isOutOfStock = {
          msg: `This item combination is out of stock.`
        };
      } else {
        delete this.errors.isOutOfStock;
      }
      if (!this.isItemAvailable(varItem)) {
        this.errors.isNotAvailable = {
          msg: `This item combination is not available.`
        };
      } else {
        delete this.errors.isNotAvailable;
      }
    }
  },
  mounted() {
    const routeParams = this.$route.params;

    if (routeParams.itemNumber) {
      this.itemNumber = routeParams.itemNumber
      this.cartItem = this.$store.getters['cart/cartItem'](this.itemNumber);
      this.itemId = this.cartItem.itemId;
    } else if (routeParams.itemId) {
      this.itemId = routeParams.itemId
      this.cartItem = {}
    }
    this.item = this.getItem(this.itemId);
    this.isItemUpdate = false;
    if (this.item.variants) {
      this.defaultVarSelection();
      this.defaultVarComb();
      return;
    }
    this.varItem = this.item;
  },

  beforeRouteLeave (to, from, next) {
    if (!this.isItemUpdate) {
      this.$store.dispatch("cart/removeItem", this.cartItem.itemNumber);
    }
    next()
  },

  methods: {
    addItem(params) {
      this.$store.dispatch("cart/addItem", params);
    },

    updateItem(item) {
      this.$store.dispatch("cart/updateItem", item);
    },

    removeItem() {
      this.$store.dispatch("cart/removeItem", this.cartItem.itemNumber);
      this.handleClose();
    },

    closeDialog() {
      if (!Util.isEmpty(this.errors)) {
        this.errors = {};
        this.removeItem();
        return;
      }
      this.handleClose();
    },

    addAction() {
      if (
        !Util.isEmpty(this.errors.optionSetErrors) ||
        !Util.isEmpty(this.errors.isOutOfStock)
      ) {
        // Toast logic to displaying errors
        if (!Util.isEmpty(this.errors.optionSetErrors)) {
          this.displayNotification = true;
        }
        return;
      }
      this.isItemUpdate = true;
      this.handleClose();
    },

    getOptionSetName(optionsetId) {
      return this.$store.getters["catalog/getOptionSet"](optionsetId).name;
    },

    selectVariant(varSelection) {
      let varId = null;

      if (
        Util.isEmpty(this.varMap) ||
        Util.isEmpty(varSelection) ||
        Object.keys(varSelection).length !== this.item.variantAttributes.length
      ) {
        return false;
      }

      varId = this.findVarByVal(this.varSelection);
      this.active_var = varId;
      if (!Util.isEmpty(this.cartItem)) {
        this.$store.dispatch("cart/removeItem", this.cartItem.itemNumber);
      }
      this.addItem({
        itemId: this.itemId,
        variantItemId: varId,
        cb: cartItem => {
          this.cartItem = cartItem;
        }
      });
    },

    tagName(tagId) {
      if (!tagId) {
        return "";
      }
      return this.$store.getters["catalog/getTag"](tagId).name;
    },

    getVairantPrice(varItem) {
      if (!varItem) {
        return "";
      }

      return this.formatPrice(this.itemPrice(varItem));
    },

    formatPrice(number) {
      return Util.formatPrice(number);
    },

    defaultVarSelection() {
      if (!this.item || !this.item.variants) {
        return {};
      }
      const varPriceMap = [];

      this.item.variants.forEach(varItem => {
        varPriceMap.push({
          price: this.itemPrice(varItem),
          val: {
            varId: varItem.mid,
            varValue: Util.convertNamValToObj(varItem.variantValues, {
              name: "name",
              value: "value"
            })
          }
        })
      });

      varPriceMap.sort((a, b) => {
        if (a.price < b.price) return -1
        if (a.price > b.price) return 1
        return 0
      });

      this.varMap = Util.pluck(varPriceMap, 'val');
      this.varSelection = Util.cloneObj(this.varMap[0]).varValue;
    },

    findVarByVal(varVal) {
      if (Util.isEmpty(varVal)) {
        return null;
      }
      const varObj = this.varMap.find(
        varItem => JSON.stringify(varItem.varValue) === JSON.stringify(varVal)
      );

      if (!varObj) {
        return null;
      }
      return varObj.varId;
    },

    getVairantPriceByValue(varrAttr, varValue) {
      let varAttrValComb = Util.cloneObj(this.varSelection);
      if (varAttrValComb[varrAttr.name] !== varValue) {
        varAttrValComb[varrAttr.name] = varValue;
      }
      const varItem = this.item.variants.find(
        varItem => varItem.mid === this.findVarByVal(varAttrValComb)
      );
      if (varItem) {
        return this.getVairantPrice(varItem);
      }
      return "";
    },

    defaultVarComb() {
      let firstVarAttr = this.item.variantAttributes[0].name;

      this.defineVariantComb(firstVarAttr, this.varSelection[firstVarAttr]);
    },

    getMinMaxText(optionSet) {
      let min = optionSet.min;
      let max = optionSet.max;
      let str = " ( Pick ";
      let strEnd = " )";

      if (!min && !max) {
        return;
      }
      if (min === max) {
        return str + max + strEnd;
      }
      if (!max) {
        return str + " at least " + min + strEnd;
      }
      if (!min) {
        return str + " up to " + max + strEnd;
      }
      return str + min + " to " + max + strEnd;
    },

    defineVariantComb(varAttr, varVal) {
      const selectVal = [varAttr, varVal].join(":");
      let varAttrComb = [];
      let itemAttr = this.item.variantAttributes;
      const variantCombimation = this.variantCombimation;

      itemAttr.forEach(varAttr => {
        let allowedValues;

        if (variantCombimation[selectVal]) {
          allowedValues = variantCombimation[selectVal][varAttr.name];
        }
        if (allowedValues) {
          let newVarValues = [];
          varAttr.values.forEach(val => {
            if (allowedValues.includes(val.value)) {
              newVarValues.push({
                value: val.value
              });
            }
          });
          varAttrComb.push({
            name: varAttr.name,
            values: newVarValues
          });
        } else if (itemAttr.length === 1) {
          varAttrComb.push({
            name: varAttr.name,
            values: this.formValidCombos(varAttr)
          });
        } else {
          varAttrComb.push(varAttr);
        }
      });
      this.varAttrComb = varAttrComb;
    },

    formValidCombos(varAttr) {
      let varCombs = varAttr.values.map(val => {
        let label = {};
        label[varAttr.name] = val.value;
        return {
          label: label,
          values: val
        };
      });

      varCombs = varCombs.filter(varComb => {
        return this.findVarByVal(varComb.label);
      });

      return Util.pluck(varCombs, "values");
    },

    updateOptionSets() {
      if (!this.varItem || Util.isEmpty(this.varItem.priceInfo.optionSetIds)) {
        this.optionSets = [];
        return null;
      }

      this.optionSets = this.varItem.priceInfo.optionSetIds.reduce(
        (optionSets, optionSetId) => {
          optionSets[optionSetId] = this.getOptionSet(optionSetId);
          return optionSets;
        },
        {}
      );
    },
    createCartItemOptions() {
      if (Util.isEmpty(this.optionSets)) {
        return {};
      }
      let cartItemOptions = [];
      Object.values(this.optionSets).forEach(optionSet => {
        if (optionSet) {
          let optionSetClone = Util.cloneObj(optionSet);

          optionSetClone.options.forEach(option => {
            if (option) {
              const optionClone = Util.cloneObj(option);
              const isSoldOut = this.isOutOfStock(option.itemId)
              cartItemOptions.push({
                optionSetId: optionSet.mid,
                itemName: optionClone.optionName,
                name: optionClone.name,
                unitPrice: optionClone.price,
                itemId: optionClone.itemId,
                uid: optionClone.uid,
                itemType: optionClone.itemType,
                skuCode: optionClone.skuCode,
                baseQty: !isSoldOut && optionClone.isDefault ? 1 : 0
              });
            }
          });
        }
      });

      this.cartItemOptions = Util.arrayToKeyValArr(cartItemOptions, "uid");
    },

    validateCartItemOptions(cartItemOptions) {
      let optionSetTotal = Object.values(cartItemOptions).reduce(
        (optionSetTotalQty, cartItem) => {
          if (!optionSetTotalQty[cartItem.optionSetId]) {
            optionSetTotalQty[cartItem.optionSetId] = 0;
          }
          optionSetTotalQty[cartItem.optionSetId] += cartItem.baseQty || 0;
          return optionSetTotalQty;
        },
        {}
      );

      this.errors.optionSetErrors = {};
      if (Util.isEmpty(optionSetTotal)) {
        return;
      }
      Object.values(this.optionSets).forEach(optionSet => {
        if (optionSet) {
          const optionSetId = optionSet.mid;
          const total = optionSetTotal[optionSet.mid];
          this.errors.optionSetErrors[optionSetId] = {
            msg: ""
          };
          if (optionSet.min && optionSet.min > total) {
            this.errors.optionSetErrors[optionSetId].msg = [
              "Should have minimum of",
              optionSet.min,
              "addon"
            ].join(" ");
          }
          if (optionSet.max && optionSet.max < total) {
            this.errors.optionSetErrors[optionSetId].msg += [
              "Should not be more than",
              optionSet.max,
              "addon"
            ].join(" ");
          }
          if (this.errors.optionSetErrors[optionSetId].msg === "") {
            delete this.errors.optionSetErrors[optionSetId];
          }
        }
      });
    },

    updateCartItemOptions(cartItemOptions) {
      if (!Util.isEmpty(this.errors)) {
        this.closeNotification();
        return;
      }
      this.cartItem.itemOptionList = Object.values(cartItemOptions).filter(
        cartItemOption => cartItemOption.baseQty > 0
      );
      this.updateItem(this.cartItem);
    },

    closeNotification() {
      this.displayNotification = false;
    },

    handleClose() {
      this.$router.go(-1);
    }
  }
};
</script>
